import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { useTranslation } from "../i18n";

export default function ConfirmDialog({
  open,
  onOpenChange,
  title,
  itemName,
  confirmText,
  onConfirm,
  isDeleteCard,
}) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="border-c-red-500 border-2 max-w-md">
        <DialogHeader>
          <DialogTitle>
            {title ||
              (isDeleteCard
                ? t("confirm.deleteCardTitle")
                : t("confirm.archiveTitle"))}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <p className="text-c-gray-300">
            {isDeleteCard
              ? t("confirm.deleteCardMessage", { item: itemName || "" })
              : t("confirm.archiveMessage", { item: itemName || "" })}
          </p>
          <div className="bg-c-red-500/20 border border-c-red-500/30 rounded p-3">
            <p className="text-c-red-400 text-sm">
              {isDeleteCard
                ? t("confirm.deleteCardWarning")
                : t("confirm.archiveWarning")}
            </p>
          </div>
        </div>
        <DialogFooter className="flex justify-between sm:justify-between">
          <Button variant="secondary" onClick={() => onOpenChange(false)}>
            {t("common.cancel")}
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            {confirmText ||
              (isDeleteCard
                ? t("confirm.deleteCardAction")
                : t("confirm.archiveAction"))}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
